@if (item) {
  <form [formGroup]="form">
    <ion-card class="ion-no-padding ion-no-margin">
      <ion-card-content class="ion-no-padding">
        <ion-item lines="full">
          <ion-input label="Name" labelPlacement="floating" formControlName="name"
            (ionBlur)="updateName()" data-testid="fermenter-name"></ion-input>
        </ion-item>

        <ion-item lines="full">
          <ion-input label="Description" labelPlacement="floating" formControlName="description"
            (ionBlur)="updateDescription()" data-testid="fermenter-description"></ion-input>
        </ion-item>

        <ion-grid style="display: flex; flex-flow: column">
          <ion-row>
            @for (t of types; track t.value) {
              <ion-col size-xs="4" size-md="2">
                <ion-button class="icon-btn" [ngClass]="{ selected: form.value.type === t.value }"
                  (click)="setType(t.value)" fill="clear" [title]="t.label"
                  [attr.data-testid]="'fermenter-type-' + t.value">
                  <app-fermenter-svg class="type-svg" [item]="typePreview(t.value)" />
                </ion-button>
              </ion-col>
            }
          </ion-row>
        </ion-grid>

        <ion-item lines="full">
          <ion-input [label]="'Size (' + (units.kegs || '') + ')'" labelPlacement="floating"
            formControlName="size" type="number" inputmode="decimal"
            (ionBlur)="updateSize()" data-testid="fermenter-size"></ion-input>
        </ion-item>

        <ion-item lines="full">
          <ion-input [label]="'Amount (' + (units.kegs || '') + ')'" labelPlacement="floating"
            formControlName="amount" type="number" inputmode="decimal"
            (ionBlur)="updateAmount()" data-testid="fermenter-amount"></ion-input>
        </ion-item>

        <!-- While a Brewfather batch is linked, Brewfather replaces the beverage
             as the source for name/colour — the row is hidden. -->
        @if (!item.brewfatherBatchId) {
          <ion-item lines="full">
            <ion-label>Beverage</ion-label>
            @if (beverage && item.beverageId) {
              <ion-button (click)="openBeer(item.beverageId)" fill="solid" color="light" slot="end"
                data-testid="fermenter-beverage">
                {{ beverage.name }}
              </ion-button>
            }
            @if (item.beverageId) {
              <ion-button (click)="deleteBeverage()" slot="end" fill="clear" shape="round" color="danger"
                size="default" data-testid="fermenter-beverage-remove">
                <ion-icon size="small" slot="icon-only" name="trash-outline"></ion-icon>
              </ion-button>
            }
            @if (!item.beverageId && item.id) {
              <ion-button (click)="openBeverageModal()" slot="end" fill="clear" shape="round" color="success"
                size="default" data-testid="fermenter-beverage-add">
                <ion-icon size="small" slot="icon-only" name="add-circle-outline"></ion-icon>
              </ion-button>
            }
          </ion-item>
        }

        @if (!!allLocations) {
          <ion-item lines="none">
            <ion-select label="Location" labelPlacement="floating" formControlName="location" interface="popover"
              (ionChange)="updateLocation($event)" data-testid="fermenter-location">
              <ion-select-option value="">Choose location</ion-select-option>
              @for (location of allLocations; track location) {
                <ion-select-option [value]="location.id">
                  {{ location.name }}
                </ion-select-option>
              }
            </ion-select>
          </ion-item>
        }
      </ion-card-content>
    </ion-card>

    @if (brewfather) {
      <div class="ion-margin-top">
        <ion-text color="medium">
          <h6 style="margin-top:0;">Brewfather</h6>
        </ion-text>
        <ion-card class="ion-no-margin ion-no-padding">
          <ion-card-content class="ion-no-padding">
            <ion-item [lines]="item.brewfatherBatchId ? 'full' : 'none'">
              <ion-label>Batch</ion-label>
              @if (item.brewfatherBatchId) {
                <ion-button (click)="openBatchPicker()" fill="solid" color="light" slot="end"
                  data-testid="fermenter-bf-batch">
                  {{ item.brewfatherBatchName || 'Linked batch' }}
                </ion-button>
                <ion-button (click)="unlinkBatch()" slot="end" fill="clear" shape="round" color="danger"
                  size="default" data-testid="fermenter-bf-unlink">
                  <ion-icon size="small" slot="icon-only" name="trash-outline"></ion-icon>
                </ion-button>
              } @else {
                <ion-button (click)="openBatchPicker()" slot="end" fill="clear" shape="round" color="success"
                  size="default" data-testid="fermenter-bf-link">
                  <ion-icon size="small" slot="icon-only" name="add-circle-outline"></ion-icon>
                </ion-button>
              }
            </ion-item>
            @if (item.brewfatherBatchId) {
              @if (item.fermentationStage) {
                <ion-item lines="full">
                  <ion-label>Status</ion-label>
                  <ion-note slot="end" data-testid="fermenter-bf-status">{{ item.fermentationStage }}</ion-note>
                </ion-item>
              }
              @if (item.originalGravity) {
                <ion-item lines="full">
                  <ion-label>OG</ion-label>
                  <ion-note slot="end" data-testid="fermenter-bf-og">{{ item.originalGravity | number:'1.3-3' }}</ion-note>
                </ion-item>
              }
              @if (item.currentGravity) {
                <ion-item lines="full">
                  <ion-label>Gravity (SG)</ion-label>
                  <ion-note slot="end" data-testid="fermenter-bf-sg">{{ item.currentGravity | number:'1.3-3' }}</ion-note>
                </ion-item>
              }
              @if (item.temperature != null) {
                <ion-item lines="full">
                  <ion-label>Temperature</ion-label>
                  <ion-note slot="end" data-testid="fermenter-bf-temp">{{ displayTemperature(item.temperature) }}</ion-note>
                </ion-item>
              }
              @if (attenuationProgress() !== null) {
                <ion-item lines="full">
                  <ion-label>
                    <p class="color-medium"><small>Fermentation</small></p>
                    <ion-progress-bar [value]="attenuationProgress()! / 100"
                      [color]="attenuationProgress()! >= 100 ? 'success' : 'warning'"></ion-progress-bar>
                  </ion-label>
                  <ion-note slot="end" data-testid="fermenter-bf-progress">{{ attenuationProgress() }}%</ion-note>
                </ion-item>
              }
              @if (bfReadings().length > 1) {
                <ion-item lines="full">
                  <div class="bf-chart">
                    <app-fermentation-chart [readings]="bfReadings()"
                      [og]="item.originalGravity" [fg]="item.finalGravity" />
                    <ion-note class="bf-chart-caption">
                      <span class="sg">— Gravity</span> · <span class="temp">— Temperature</span> · <span class="fg">- - FG target</span>
                    </ion-note>
                  </div>
                </ion-item>
              }
              <ion-item lines="none">
                <ion-button (click)="refreshBrewfather()" fill="clear" [disabled]="bfLoading()"
                  data-testid="fermenter-bf-refresh">
                  @if (bfLoading()) {
                    <ion-spinner name="crescent" slot="start"></ion-spinner>
                  } @else {
                    <ion-icon slot="start" name="refresh-outline"></ion-icon>
                  }
                  Refresh
                </ion-button>
              </ion-item>
            }
          </ion-card-content>
        </ion-card>
      </div>
    }
  </form>
}
